import { render, staticRenderFns } from "./LaPrairieWhiteCaviar.vue?vue&type=template&id=35b9a6e7&shadow"
import script from "./LaPrairieWhiteCaviar.vue?vue&type=script&lang=ts&shadow"
export * from "./LaPrairieWhiteCaviar.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./LaPrairieWhiteCaviar.vue?vue&type=style&index=0&lang=stylus&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./LaPrairieWhiteCaviar.vue?vue&type=style&index=1&lang=stylus&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports